<template>
  <div class="tariffs">
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th
              scope="col"
              @click="change_filter('mno')"
              class="pointer"
              :class="{ selected: filter_type === 'mno' }"
            >
              {{ translate("communication_management.tariffs.mno") }}
              <i
                class="mdi mdi-arrow-down"
                :class="{
                  reverse: filter_asc === 'asc' && filter_type === 'mno',
                }"
              ></i>
            </th>
            <th
              scope="col"
              @click="change_filter('tariff_name')"
              class="pointer"
              :class="{ selected: filter_type === 'tariff_name' }"
            >
              {{ translate("communication_management.tariffs.tariff_name") }}
              <i
                class="mdi mdi-arrow-down"
                :class="{
                  reverse:
                    filter_asc === 'asc' && filter_type === 'tariff_name',
                }"
              ></i>
            </th>
            <th
              scope="col"
              @click="change_filter('cost')"
              class="pointer"
              :class="{ selected: filter_type === 'cost' }"
            >
              {{ translate("communication_management.tariffs.cost") }}
              <i
                class="mdi mdi-arrow-down"
                :class="{
                  reverse: filter_asc === 'asc' && filter_type === 'cost',
                }"
              ></i>
            </th>
            <th
              scope="col"
              @click="change_filter('currency')"
              class="pointer"
              :class="{ selected: filter_type === 'currency' }"
            >
              {{ translate("communication_management.tariffs.currency") }}
              <i
                class="mdi mdi-arrow-down"
                :class="{
                  reverse: filter_asc === 'asc' && filter_type === 'currency',
                }"
              ></i>
            </th>
            <th
              scope="col"
              @click="change_filter('count_active')"
              class="pointer"
              :class="{ selected: filter_type === 'count_active' }"
            >
              {{ translate("communication_management.tariffs.count_active") }}
              <i
                class="mdi mdi-arrow-down"
                :class="{
                  reverse:
                    filter_asc === 'asc' && filter_type === 'count_active',
                }"
              ></i>
            </th>
            <th
              scope="col"
              @click="change_filter('count_inactive')"
              class="pointer"
              :class="{ selected: filter_type === 'count_inactive' }"
            >
              {{ translate("communication_management.tariffs.count_inactive") }}
              <i
                class="mdi mdi-arrow-down"
                :class="{
                  reverse:
                    filter_asc === 'asc' && filter_type === 'count_inactive',
                }"
              ></i>
            </th>
            <th
              scope="col"
              @click="change_filter('traffic_limit')"
              class="pointer"
              :class="{ selected: filter_type === 'traffic_limit' }"
            >
              {{ translate("communication_management.tariffs.traffic_limit") }}
              <i
                class="mdi mdi-arrow-down"
                :class="{
                  reverse:
                    filter_asc === 'asc' && filter_type === 'traffic_limit',
                }"
              ></i>
            </th>
            <th
              scope="col"
              @click="change_filter('ts_add')"
              class="pointer"
              :class="{ selected: filter_type === 'ts_add' }"
            >
              {{ translate("communication_management.tariffs.ts_add") }}
              <i
                class="mdi mdi-arrow-down"
                :class="{
                  reverse: filter_asc === 'asc' && filter_type === 'ts_add',
                }"
              ></i>
            </th>
            <th
              scope="col"
              @click="change_filter('ts_update')"
              class="pointer"
              :class="{ selected: filter_type === 'ts_update' }"
            >
              {{ translate("communication_management.tariffs.ts_update") }}
              <i
                class="mdi mdi-arrow-down"
                :class="{
                  reverse: filter_asc === 'asc' && filter_type === 'ts_update',
                }"
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="load" style="border: none; background-color: transparent">
            <td><scale-loader /></td>
          </tr>
          <tr v-else v-for="(tariff, key) in all_tariff_list" :key="key">
            <td :data-label="translate('communication_management.tariffs.mno')">
              {{ tariff.mno }}
            </td>
            <td
              :data-label="
                translate('communication_management.tariffs.tariff_name')
              "
            >
              {{ tariff.tariff_name }}
            </td>
            <td
              :data-label="translate('communication_management.tariffs.cost')"
            >
              {{ tariff.cost }}
            </td>
            <td
              :data-label="
                translate('communication_management.tariffs.currency')
              "
            >
              {{ tariff.currency }}
            </td>
            <td
              :data-label="
                translate('communication_management.tariffs.count_active')
              "
            >
              {{ tariff.count_active }}
            </td>
            <td
              :data-label="
                translate('communication_management.tariffs.count_inactive')
              "
            >
              {{ tariff.count_inactive }}
            </td>
            <td
              :data-label="
                translate('communication_management.tariffs.traffic_limit')
              "
            >
              {{ tariff.traffic_limit }}
            </td>
            <td
              :data-label="translate('communication_management.tariffs.ts_add')"
            >
              {{ ts_start(tariff.ts_add) }}
            </td>
            <td
              :data-label="
                translate('communication_management.tariffs.ts_update')
              "
            >
              {{ get_date(tariff.ts_update) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommunicationManagementTariffs",
  props: [],
  data() {
    return {
      filter_type: "status",
      filter_asc: "asc",
      tariff_list: [],
      load: true,
      options_date: {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      },
    };
  },

  mounted() {
    this.get_tariff_list();
  },
  computed: {
    all_tariff_list() {
      let list = Object.values(this.tariff_list);
      list.sort(this.compareNumbers);
      return list;
    },
  },
  methods: {
    get_tariff_list() {
      this.$http.simcard.getSimcardTariffList((response) => {
        this.tariff_list = response.data;
        this.load = false;
      });
    },
    ts_start(data) {
      return this.get_date(data, this.options_date);
    },
  },
};
</script>
<style lang='scss' scoped>
.tariffs {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  .response_table {
    thead {
      flex: 0 1 0;
    }
    td,
    th {
      &.w1 {
        width: 2.5%;
      }
      &.w3 {
        width: 7.5%;
      }
      &.w4 {
        width: 10%;
      }
      &.w10 {
        width: 25%;
      }
    }
    th {
      i {
        opacity: 0;
        width: 0;
        display: inline-block;
      }
      &.selected {
        color: #000;
        i {
          opacity: 1;
          width: auto;
        }
      }
    }
    tbody {
      tr {
        transition: 0.2s;
        cursor: pointer;
        &:hover {
          background-color: #eee;
        }
      }
    }
    .link {
      width: 50px;
    }
  }
}
.pointer {
  cursor: pointer;
}
.mdi-arrow-down {
  transform: rotate(0);
  transition: 0.2s;
  &.reverse::before {
    transform: rotate(180deg);
  }
}

.time_sync_simcard {
  cursor: pointer;
}

.link_simcard {
  cursor: pointer;
}
</style>
